import { canCheckoutOnline } from "shared/constants/checkout";
import { getCountryCookie } from "./cookies";
import { divide, multiply } from "mathjs";
import { getUrlVars } from "./url";

export const getCurrentTaxRate = (countryCode, b2bFlag) => {
  const countries = JSON.parse(document.getElementById('countries-object').innerHTML)

  const currentCountry = countries.find(country => country.id === countryCode)
  if (!!b2bFlag) {
    return countryCode === 'PT' ? 23 : 0
  }

  if (currentCountry && canCheckoutOnline()) {
    return currentCountry.taxRate
  }

  return 0
}

export const applyVat = (value) => {
  const urlVars = getUrlVars()
  const currentCountryCode = getCountryCookie()

  const taxRate = divide(100 + getCurrentTaxRate(currentCountryCode, urlVars.b2bFlag), 100)

  if (!!urlVars.b2bFlag) {
    const reducedValue = multiply(value, 0.7)
    return multiply(reducedValue, taxRate)
  }

  return multiply(value, taxRate)
}